import type { NewsMode, Segment } from './types';

export const SEGMENTS: Segment[] = ['Left', 'Neutral', 'Right'];

export const SEGMENT_COLORS: Record<Segment, string> = {
  Left: '#f45b69',
  Neutral: '#9ea5b4',
  Right: '#4c6ef5'
};

export const SEGMENT_LABELS: Record<Segment, string> = {
  Left: 'Left-leaning',
  Neutral: 'Neutral',
  Right: 'Right-leaning'
};

export const NEWS_MODES: NewsMode[] = ['political', 'general'];

export const NEWS_MODE_LABELS: Record<NewsMode, string> = {
  political: 'Political',
  general: 'General'
};

export const DEFAULT_LOCATION = 'All';
